import { Component } from 'react';
import CheckboxItem from './CheckboxItem'
import { ModuleActions } from 'Constants/Modules.constants';

class CheckboxGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parentCheckboxChecked: false,
        };
    }

    updateParentWithChildren = () => {
        const { checkboxes, onCheckboxGroupChange, checkboxGroupkey } = this.props;
        const { parentCheckboxChecked } = this.state;
        const updateCheckBox = { ...checkboxes }
        for (const property in updateCheckBox) {
            updateCheckBox[ property ] = !parentCheckboxChecked
        }
        this.setState({
            parentCheckboxChecked: !parentCheckboxChecked
        }, () => {
            onCheckboxGroupChange(checkboxGroupkey, updateCheckBox);
        })
    };

    handleChildCheckboxChange = (isChecked, checkboxname) => {
        const { checkboxes,
            checkboxGroupkey,
            onCheckboxGroupChange
        } = this.props;

        const updateCheckBox = { ...checkboxes }
        updateCheckBox[ checkboxname ] = isChecked;
        const isAnOptionTrue = Object.keys(updateCheckBox).some(key => key !== ModuleActions.view && updateCheckBox[ key ]);
        if(isAnOptionTrue && !updateCheckBox[ ModuleActions.view ] && checkboxname !== ModuleActions.view){
            updateCheckBox[ ModuleActions.view ] = true;
        }
        // When view is unchecked, Need to uncheck all the sub action
        if(checkboxname === ModuleActions.view && !isChecked){
            for (const key in checkboxes) {
                updateCheckBox[ key ] = isChecked;
            }             
        }
        const updateParent = Object.keys(updateCheckBox).some(key => !updateCheckBox[ key ]);
        this.setState({
            parentCheckboxChecked: !updateParent
        }, () => {
            onCheckboxGroupChange(checkboxGroupkey, updateCheckBox);
        })
    };

    renderCheckboxes = () => {
        const { checkboxes, checkboxGroupkey } = this.props;
        if (!checkboxes) {
            return null;
        }
        var CheckboxItemArray = [];
        for (const property in checkboxes) {
            CheckboxItemArray.push(<CheckboxItem
                checkboxname={ property }
                parentClass={ this.props.parentClass }
                checked={ checkboxes[ property ] }
                parentkey={ checkboxGroupkey }
                checkboxChangeCallback={ (checkStatus, checkboxname) => this.handleChildCheckboxChange(checkStatus, checkboxname) }
                key={ property } />)
        }
        return CheckboxItemArray;
    };

    componentDidMount() {
        this.initialSetUp()
    }

    initialSetUp = () => {
        const { checkboxes } = this.props;
        const updateParent = checkboxes && Object.keys(checkboxes).some(key => !checkboxes[ key ]);
        this.setState({
            parentCheckboxChecked: !updateParent
        })
    }

    render() {
        const { checkboxGroupkey } = this.props;
        const { parentCheckboxChecked } = this.state;
        if(checkboxGroupkey === 'Users Import' || checkboxGroupkey === 'department' || checkboxGroupkey === 'job title') return null;
        return (
            <>
                <div className='roles'>
                    <div className='parent'>
                        {/* <div className='check-box'>
                            <div className='checkbox'>
                                <input type='checkbox'
                                    checked={ parentCheckboxChecked }
                                    id={ checkboxGroupkey }
                                    onChange={ this.updateParentWithChildren }
                                />
                                <label htmlFor={ checkboxGroupkey }>
                                    <span name={ checkboxGroupkey }>{checkboxGroupkey}</span>
                                </label>
                            </div>
                        </div> */}
                        <div className={ `cus-checkbox ${ parentCheckboxChecked ? 'active' : '' }` } >
                            <input type="checkbox" 
                                checked={ parentCheckboxChecked }
                                id={ checkboxGroupkey }
                                onChange={ this.updateParentWithChildren }
                            />
                            <label htmlFor={ checkboxGroupkey }>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" fill="none" stroke-width="2px" stroke="white" stroke-linecap="round" viewBox="0 0 21 21">
                                        <polyline points="5 10.75 8.5 14.25 16 6"></polyline>
                                    </svg>
                                </span>
                                {checkboxGroupkey}
                            </label>
                        </div>
                    </div>
                    <ul>
                        {this.renderCheckboxes()}
                    </ul>
                </div>
            </>
        )
    }
}

export default CheckboxGroup;